export class UniversalCalculationItem {
    PartID: number;
    PartCategory: any;
    PartDescription: any;
    GeneralDescription: string;
    YearOfPurchase: number;
    DayValueAmount: number;
    EstablishedDamageAmount: number;
    VATType: any;
    WG?: any;
    SubReport?: any;

    public constructor(init?: Partial<UniversalCalculationItem>) {
        Object.assign(this, init);
    }
}
